import sharedServiceContent from "./service-content.cjs";

export const navigation = [
  ["Home", "/"],
  ["Warehousing", "/cold-room-warehousing"],
  ["E-Commerce Fulfilment", "/ecommerce-fulfilment"],
  ["Refrigerated Transport", "/refrigerated-transport"],
  ["Distribution", "/distribution"],
  ["Cross-Border", "/cross-border-logistics"],
  ["4PL Solutions", "/4pl-solutions"],
  ["Insights", "/insights"],
  ["Track Shipment", "/track"],
  ["About", "/about"],
];

export const serviceRoutes = {
  warehousing: "/cold-room-warehousing",
  fulfilment: "/ecommerce-fulfilment",
  transport: "/refrigerated-transport",
  distribution: "/distribution",
  "cross-border": "/cross-border-logistics",
  "4pl": "/4pl-solutions",
};

export const servicePages = sharedServiceContent.servicePages;

export const industryUses = [
  ["Food manufacturers", "Move ingredients and finished goods between production, storage and customers."],
  ["Frozen and chilled brands", "Coordinate storage, order preparation and temperature-sensitive delivery."],
  ["Restaurants and café chains", "Plan repeat deliveries across several operating locations."],
  ["Retailers and supermarkets", "Prepare replenishment and multi-outlet distribution workflows."],
  ["Importers and exporters", "Manage cross-border handovers, forwarding and onward distribution."],
  ["Healthcare and pharmaceutical companies", "Record handling requirements for management review before commitment."],
  ["E-commerce sellers and MSMEs", "Prepare for professionally managed storage, fulfilment and dispatch."],
  ["Hospitality and regional distributors", "Bring stock holding and delivery coordination into one operating plan."],
];
